import React, { useEffect, useState } from 'react';

/**
 * HupalupaKasimAralik2026: HUPALUPA Store Kasım – Aralık 2026 yol haritası.
 * Route: /reports/hupalupa-kasim-aralik-2026 (sidebar YOK, tam ekran slayt gösterisi)
 *
 * 24 slayt, 16:9, apple.com tasarım dili, performans destesiyle aynı hattan.
 * Veri: glowytics-backend/scripts/hupalupa_kasim_aralik.js, dondurulmuş. Yeniden üret:
 *   node src/pages/hupalupa-kasim-aralik-2026/build.js
 *
 * 🔑 "PDF olarak indir" düğmesi belgenin İÇİNDE. iframe dışından Ctrl+P
 * slaytları tek sayfaya kırpar; düğmeyi dışarı taşıma.
 * 🔴 iframe'e sandbox EKLEME, PDF indirme kırılır.
 *
 * HTML modülü ~170KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function HupalupaKasimAralik2026() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('../hupalupaKasimAralikHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="HUPALUPA Store · Kasım – Aralık 2026 yol haritası"
      srcDoc={html}
      style={fill}
    />
  );
}
